module.exports = __webpack_public_path__ + "img/vuma-crs-big.4c1f4e44.jpg";